module.exports = __webpack_public_path__ + "static/img/部件组成2-显示屏.ad170d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-2/部件组成2-显示屏.png
// module id = hU+b
// module chunks = 0